import React, { useState } from 'react';
import { CompassOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import LocalStorage from '@shared/utils/localStorage';
import GuideModal from '../../GuideModal';
import './styles.less';
import { useTranslation } from 'react-i18next';

export const GuideEntry = () => {
  const [open, setOpen] = useState(false);
  const prefixCls = 'guide-entry';
  const { t } = useTranslation('app', { keyPrefix: 'layout.header' });

  return (
    <>
      <Button 
        className={`${prefixCls}-btn`}
        icon={<CompassOutlined className="icon" />}
        type="text"
        onClick={() => {
          setOpen(true);
          LocalStorage.setTemplateCenterVisited(false);
        }}
      >
        {t('guide')}
      </Button>
      <GuideModal 
        open={open} 
        onClose={() => setOpen(false)} 
        product={t('title')} 
      />
    </>
  );
};
